import { Controller } from "@hotwired/stimulus"

// Controller for managing auto-translation checkbox behavior
export default class extends Controller {
  static targets = ["checkbox", "input"]

  connect() {
    // Initialize input states based on checkbox
    this.updateInputStates()
  }

  toggle(event) {
    this.updateInputStates()
  }

  updateInputStates() {
    const isAutoTranslate = this.checkboxTarget.checked

    this.inputTargets.forEach(input => {
      if (isAutoTranslate) {
        // Disable inputs when auto-translate is enabled
        input.disabled = true
        input.classList.add("bg-gray-100", "cursor-not-allowed", "opacity-60")
        input.classList.remove("bg-white")
      } else {
        // Enable inputs when auto-translate is disabled
        input.disabled = false
        input.classList.remove("bg-gray-100", "cursor-not-allowed", "opacity-60")
        input.classList.add("bg-white")
      }
    })
  }
}
